import { FlexBox } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const Wrapper = styled(FlexBox)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #909090;
    font-size: 17px;
    line-height: 22px;
    white-space: nowrap;
`;

export const HiddenContentText: FC = () => {
    const { t } = useTranslation();
    return (
        <Wrapper>{t('hide_content')}</Wrapper>
    )
}import { FlexBox } from "@brg/ui";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

export const Wrapper = styled(FlexBox)`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #909090;
    font-size: 17px;
    line-height: 22px;
    white-space: nowrap;
`;

export const HiddenContentText: FC = () => {
    const { t } = useTranslation();
    return (
        <Wrapper>{t('hide_content')}</Wrapper>
    )
}